/**
 * Programme feedback templates (admin-authored) and the learner's submission.
 * Same fallback pattern as certificate.ts: a template with a null
 * programmeId is a global default usable by any programme, overridable by a
 * programme-specific template.
 */
import { z } from "zod";
export const FEEDBACK_QUESTION_TYPES = ["RATING_5", "NPS_0_10", "TEXT", "SINGLE_CHOICE"];
export const feedbackQuestionSchema = z
    .object({
    id: z.string().min(1).max(60),
    text: z.string().trim().min(1).max(500),
    type: z.enum(FEEDBACK_QUESTION_TYPES),
    options: z.array(z.string().trim().min(1).max(200)).min(2).max(10).optional(),
})
    .refine((v) => v.type !== "SINGLE_CHOICE" || (v.options?.length ?? 0) >= 2, {
    message: "SINGLE_CHOICE questions need at least two options",
    path: ["options"],
});
export const createFeedbackTemplateSchema = z.object({
    title: z.string().trim().min(1).max(200),
    // null = a global fallback template usable by any programme without one of
    // its own — same convention as CertificateTemplate.
    programmeId: z.string().min(1).nullable().default(null),
    questions: z.array(feedbackQuestionSchema).min(1).max(20),
});
export const updateFeedbackTemplateSchema = z.object({
    title: z.string().trim().min(1).max(200).optional(),
    questions: z.array(feedbackQuestionSchema).min(1).max(20).optional(),
    active: z.boolean().optional(),
});
const feedbackAnswerSchema = z.object({
    questionId: z.string().min(1),
    // RATING_5/NPS_0_10 are submitted as their numeric value stringified; kept
    // as a plain string end-to-end like every other free-form answer here,
    // since nothing server-side does arithmetic on a single answer — only the
    // aggregate report does, and that parses numerically there.
    value: z.string().trim().min(1).max(2000),
});
export const submitFeedbackSchema = z.object({
    templateId: z.string().min(1),
    answers: z.array(feedbackAnswerSchema).min(1).max(50),
});
//# sourceMappingURL=feedback.js.map